import * as React from 'react';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';


const ElementRecursif = React.memo(({
    row,
    columns,
    columnsParameter,
    onOpenDeleteDialog }) => {

    /** Gestion des décalages d'affichage des niveaux */
    const paddingNiveau = [
        { niveau: 'G', valeur: 2 },
        { niveau: 'SG', valeur: 5 },
        { niveau: 'F', valeur: 8 },
        { niveau: 'SF', valeur: 11 },
    ]

    /** Récupération du padding du niveau */
    const getPaddingNiveau = (niveau) => {
        return paddingNiveau.find(x => x.niveau === niveau).valeur;
    }

    /** Composant récursif d'un élément et ses enfants */
    const ElementWithChildrenComponent = React.memo(({ row }) => {

        const randRow = Math.floor(Math.random() * 1000);

        const hasChildren = row && row.enfants.length > 0;

        /** Hook affichage des enfants */
        const [open, setOpen] = React.useState(true);

        return (
            <>
                <TableRow hover key={`row-${row.niveau}-${row.code}-${randRow}`} >
                    {columns.map((column, index) => {

                        const randCell = Math.floor(Math.random() * 1000);

                        return (
                            <TableCell
                                key={`cel-${row.niveau}-${row.code}-${randCell}-${index}`}
                                align={column.align}
                                sx={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    pl: getPaddingNiveau(row.niveau)
                                }}
                            >
                                {column.data === 'niveau' &&
                                    (hasChildren ?
                                        <span>
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => setOpen(!open)}
                                            >
                                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}

                                            </IconButton>
                                            {row[column.data]}
                                        </span>
                                        :
                                        <span>
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                disabled
                                            >
                                                <KeyboardArrowUpIcon sx={{ color: 'transparent' }} />

                                            </IconButton>
                                            {row[column.data]}
                                        </span>
                                    )
                                }

                                {column.data !== 'niveau' && (
                                    <Box>
                                        {column.render ? column.render() : row[column.data]}
                                    </Box>
                                )}

                            </TableCell>
                        );
                    })}

                    {columnsParameter.map((typeArbo, index) => {

                        const randType = Math.floor(Math.random() * 1000);

                        const isParametre = row.parametres.find(x => x === index) !== undefined;

                        return (
                            <TableCell
                                key={`cel-${index}-${randType}`}
                                align='left'
                                sx={{ backgroundColor: theme => theme.palette.background.paper }}
                            >
                                {isParametre &&
                                    <Checkbox
                                        sx={{ pt: 0, pb: 0 }}
                                        checked={true}
                                        onChange={() => onOpenDeleteDialog(row.niveau, row.code, row.libelle, index)}
                                    />
                                }
                            </TableCell>
                        )
                    })}
                </TableRow>

                {/** Lignes des enfants */}
                {
                    open && hasChildren && row.enfants.map((enfant) => (
                        <ElementWithChildrenComponent key={`child-${enfant.niveau}-${enfant.code}`} row={enfant} />
                    ))
                }
            </>
        )
    })

    ElementWithChildrenComponent.displayName = "RowsWithChildrenComponent";

    return (
        <>
            <ElementWithChildrenComponent row={row} />
        </>
    );
})

ElementRecursif.displayName = "ElementRecursif";

export default ElementRecursif;